import { createAction } from "@reduxjs/toolkit";

export const orderReset = createAction("app/orderReset");
